import React from "react";
import { Container } from 'react-bootstrap';
import {Link} from "react-router-dom";
import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner gdback">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">BIG DATA AND ANALYTICS</h2>
						<div className="red-border"> </div>
						<p>digiPanda provides big data analytics services to help enterprises integrate and bring together large volumes of data, transform & analyze the same leading to critical business decision making.</p>
						<Link to="/portfolio" className="red-btn"> Explore Our Work </Link>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
